import NuevaReservacionMultiple from './NuevaReservacionMultiple';

// Componente wrapper - ahora soporta múltiples OCs
const NuevaReservacion = () => {
  return <NuevaReservacionMultiple />;
};

export default NuevaReservacion;
